<select class="form-control" [(ngModel)]="periodo" (ngModelChange)="onChangeSelect($event)">
    <option *ngFor="let subPeriodo of periodos" [ngValue]="subPeriodo">
        {{ periodosConfig[subPeriodo[1]].label }} {{ subPeriodo[0]}}
    </option>
</select>
